import React, { Component } from "react";
import $ from "jquery";
import ImgWithSrcset from './ImgWithSrcset';

class Image extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: false
        };
    }

    render() {
        let { src, svg, className, alt, placeholderText, ...otherProps } = this.props;

        if (!src && svg) {
            let parser = new DOMParser();
            let doc = parser.parseFromString(svg, "image/svg+xml");
            let svgHtml = $(doc)
                .find("svg")
                .get(0).outerHTML;

            return <div className={className} dangerouslySetInnerHTML={{ __html: svgHtml }} />;
        }

        let placeholder = "http://via.placeholder.com/1000?text=placeholder" + (placeholderText ? "%0A" + placeholderText : "");

        if (this.state.error) src = placeholder;

        src = src || placeholder;

        return <ImgWithSrcset src={src} alt={alt} className={className} onError={() => this.setState({ error: true })} {...otherProps} />;
    }

    componentWillReceiveProps() {
        this.setState({ error: false });
    }
}
export default Image;



// WEBPACK FOOTER //
// ./src/components/Image.js